import { PromocodeBaseModel } from './promocode-base.model';

export class PromocodePrivateFilterModel extends PromocodeBaseModel {
  filter: any;
}
